module.exports = __webpack_public_path__ + "img/glass-citrus.7d749315.svg";